import { render, staticRenderFns } from "./NewFileItem.vue?vue&type=template&id=7e4380de"
import script from "./NewFileItem.vue?vue&type=script&lang=js"
export * from "./NewFileItem.vue?vue&type=script&lang=js"
import style0 from "./NewFileItem.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports